// extracted by mini-css-extract-plugin
module.exports = {"products":"OQ-z","misad":"PQ-z","oosMessaging":"QQ-z","topProductFrame":"RQ-z","productCardOverrides":"SQ-z","secondRowAds":"TQ-z","microsoftAdsWrapper":"UQ-z"};